// App.js
import React from 'react';
import Navbar from './Components/Navbar';
import Gallery from './Components/Gallery';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Gallery />
    </div>
  );
}

export default App;
